import React, { useRef } from "react";
import Icon from "../Icon";
import { grad, hueFor } from "../../lib/gradients";

/** "Club Life" photo tiles (mockup `.carousel` + `.life` + `.tile`); arrows are desktop-only. */
export default function ClubLifeCarousel({ tiles, onOpen }) {
  const ref = useRef(null);
  const by = (dir) => ref.current?.scrollBy({ left: dir * 320, behavior: "smooth" });
  return (
    <div className="carousel">
      <button type="button" className="arrow l hide-sm" onClick={() => by(-1)} aria-label="Scroll left" data-testid="home.clubLife.prev"><Icon name="left" /></button>
      <div className="life" ref={ref}>
        {tiles.map((t, i) => (
          <button
            key={t.key}
            type="button"
            className="tile"
            style={{ background: `url("${t.url}") center / cover, ${grad(hueFor(t.clubId))}` }}
            onClick={() => onOpen(t.club)}
            data-testid={`home.clubLife.${i}`}
          >
            <b>{t.name}</b>
            {t.club.category ? <small>{t.club.category}</small> : null}
          </button>
        ))}
      </div>
      <button type="button" className="arrow r hide-sm" onClick={() => by(1)} aria-label="Scroll right" data-testid="home.clubLife.next"><Icon name="right" /></button>
    </div>
  );
}
